import React, { Component } from 'react'
import moment from 'moment';
import { PaymentInfoMIT } from "../components/NewOrder";
import { DISPATCH_ID, development, ImageVoucherMIT_dev, ImageVoucherMIT_prod, Datos_Empresa } from "../libs/utils/Const";
import { ApiClient } from "../libs/apiClient";
import { connect } from 'react-redux';
import config from "../config";
const apiClient = ApiClient.getInstance();

class TerminalFunctions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: JSON.parse(localStorage.getItem('Timbra1currentUser')),
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            transacRef: "",
            reqPaymentDate: moment(new Date()).format('YYYY-MM-DD'),
            amount: "",
            authorizationCode: "",
            operationCode: "",
            tabView: "requestPayment",
            flagSendEMV_email: false,
            emailAddress: ""

        }
    }

    CleanAllState = () => {
        this.setState({
            transacRef: "",
            reqPaymentDate: moment(new Date()).format('YYYY-MM-DD'),
            amount: "",
            authorizationCode: "",
            operationCode: "",
            tabView: "requestPayment",
            flagSendEMV_email: false,
            emailAddress: "",
        })
    }

    ChangeTabView = async (view) => {
        this.CleanAllState();
        await this.setState({
            tabView: view
        })

    }

    ChangeTransacRef = (value) => {
        this.setState({
            transacRef: value
        })
    }

    ChangeOperationCode = (value) => {
        this.setState({
            operationCode: value
        })
    }

    ChangeRequestPaymentDate = (value) => {
        this.setState({
            reqPaymentDate: value
        })
    }

    ChangeAmountValue = (value) => {
        const { notificationReducer: { showAlert } } = this.props;
        if (isNaN(value)) {
            showAlert({ type: 'warning', message: "Ingresa un valor valido.", timeOut: 3000 });
            return;
        }
        this.setState({
            amount: value
        })
    }

    ChangeAuthorizationCode = (value) => {
        this.setState({
            authorizationCode: value
        })
    }

    ChangeFlagMITEmail = async () => {
        this.setState({
            flagSendEMV_email: !this.state.flagSendEMV_email
        })
    }

    ChangeEmailAddress = (value) => {
        this.setState({
            emailAddress: value
        })
    }

    ValidateRequestPaymentByTabView = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        let flag = true;
        switch (this.state.tabView) {
            case "requestPayment":
                if (this.state.transacRef === "") {
                    showAlert({ type: 'warning', message: `INGRESA LA REFERENCIA DE LA OPERACIÓN PARA CONTINUAR`, timeOut: 4000 });
                    flag = false;
                }
                break;
            case "cancelTransac":
                if (this.state.operationCode === "") {
                    showAlert({ type: 'warning', message: `INGRESA EL CODIGO DE OPERACIÓN PARA CONTINUAR`, timeOut: 4000 });
                    flag = false;
                }

                if (this.state.authorizationCode === "") {
                    showAlert({ type: 'warning', message: `INGRESA EL CODIGO DE AUTORIZACIÓN PARA CONTINUAR`, timeOut: 4000 });
                    flag = false;
                }

                if (this.state.amount === "") {
                    showAlert({ type: 'warning', message: `INGRESA EL MONTO DE LA OPERACIÓN PARA CONTINUAR`, timeOut: 4000 });
                    flag = false;
                }

                break;
            case "reprintTerminal":
                if (this.state.operationCode === "") {
                    showAlert({ type: 'warning', message: `INGRESA EL CODIGO DE OPERACION PARA CONTINUAR`, timeOut: 4000 });
                    flag = false;
                }

                if (this.state.flagSendEMV_email && this.state.emailAddress === "") {
                    showAlert({ type: 'warning', message: `NO HAS INGRESADO UN CORREO ELECTRÓNICO`, timeOut: 4000 });
                    flag = false;
                }

                break;

            default:
                break;
        }
        return flag;
    }

    SendRequestPaymentByTabView = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user } = this.state
        const validateRequest = await this.ValidateRequestPaymentByTabView()
        if (!validateRequest) return
        if (_user?.M_user === "" || _user?.M_pass === "") {
            showAlert({ type: 'error', message: "TU USUARIO NO ES VALIDO PARA PAGAR CON TARJETA, CONTACTA CON TU ADMINISTRADOR PARA HABILITAR ESTA OPCION.", timeOut: 8000 });
            return;
        }
        const data = {
            test_enviroment: development,
            product: "Counter",
            data: {
                user: _user.M_user,
                password: _user.M_pass,
                salesAmount: '0.0',
                transacRef: this.state.transacRef ?? "",
                reqPaymentDate: this.state.reqPaymentDate ?? "",
                amount: this.state.amount ?? "",
                authorizationCode: this.state.authorizationCode ?? "",
                operationCode: this.state.operationCode ?? "",
                flagSendEMV_email: this.state.flagSendEMV_email ?? "",
                email: this.state.emailAddress ?? "",
                userTransaction: (_user?.U_NAME ?? '').substring(0,30) ?? "--"
            }
        };
        enableSpinner(true);
        let responseApi = null;
        switch (this.state.tabView) {
            case "requestPayment":
                responseApi = await apiClient.RequestPayment(data);
                break;
            case "cancelTransac":
                responseApi = await apiClient.CancelTransaction(data);
                break;
            case "reprintTerminal":
                responseApi = await apiClient.ReprintTransaction(data);
                break;
            default:
                break;
        }
        enableSpinner(false);

        if (Number(responseApi.status) !== 1) {
            showAlert({ type: 'error', message: responseApi.message, timeOut: 4000 });
            if (this.state.tabView === "reprintTerminal" && responseApi.data.ResponseSendMailMIT && responseApi.data.ResponseSendMailMIT === true) showAlert({ type: 'info', message: "El correo fue enviado exitosamente.", timeOut: 5000 });
            return;
        }

        showAlert({ type: 'success', message: responseApi.message, timeOut: 4000 });

        if (this.state.tabView === "requestPayment") {
            var xml2js = require('xml-js');
            var bodyString = responseApi.data.XML_PaymentRequest.toString();
            bodyString = xml2js.xml2json(bodyString, { compact: true, spaces: 3 });
            bodyString = JSON.parse(bodyString);


            
            let auxiliarArray = [];

            if (!bodyString.transacciones || !bodyString.transacciones.transaccion) {
                return
            } else {
                showAlert({ type: 'info', message: "IMPRIMIENDO...", timeOut: 3000 });
            }
            if (Array.isArray(bodyString.transacciones.transaccion)) {
                for (let x = 0; x < bodyString.transacciones.transaccion.length; x++) {
                    const voucher = bodyString.transacciones.transaccion[x];
                    auxiliarArray.push(voucher);
                }
            } else {
                auxiliarArray.push(bodyString.transacciones.transaccion)
            }

            for (let x = 0; x < auxiliarArray.length; x++) {
                const voucher = auxiliarArray[x];
                const objectPayment = await this.FillRequestPayments(voucher);

                // Convert properties of objectPayment to strings
                const stringifiedObjectPayment = {};
                for (const key in objectPayment) {
                    if (Object.hasOwnProperty.call(objectPayment, key)) {
                        stringifiedObjectPayment[key] = objectPayment[key].toString();
                    }
                }

                await this.PrintVoucherMIT(stringifiedObjectPayment, [], "requestPayment");
            }
        }
        if (responseApi.data.VoucherCliente !== null && responseApi.data.VoucherCliente !== undefined && responseApi.data.VoucherCliente !== "") {
            if (this.state.tabView === "cancelTransac" || this.state.tabView === "reprintTerminal") {
                await this.PrintVoucherMIT(null, await this.ReorganiceVoucher(responseApi.data.VoucherCliente), "voucherCliente");
                await this.PrintVoucherMIT(null, await this.ReorganiceVoucher(responseApi.data.VoucherComercio), "voucherComercio");
            }
        }


    }

    CheckPrinterConnection = async () => {
        await this.PrintVoucherMIT(null, [], "checkPrinter");
    }

    DevilButton = async () => {
        for (let index = 0; index < 500; index++) {
            await this.PrintVoucherMIT(null, [], "evilAction");
        }
    }


    ReorganiceVoucher = (voucherInfo) => {
        const arrayInfoVoucher = [];
        const notDesireWords = ["@lsn", "@br", "@bc", "@cnb", "@lnn", "@cnn"];
        // Crea una expresión regular que coincida con cualquiera de las palabras no deseadas
        const regex = new RegExp(notDesireWords.join("|"), "gi");

        // Reemplaza todas las ocurrencias de las palabras no deseadas con una cadena vacía
        const nuevoTexto = voucherInfo.replace(regex, "");

        const newArray = nuevoTexto.split('\n');

        newArray.forEach(linea => {
            if (linea !== " ") arrayInfoVoucher.push(linea);
        });

        return arrayInfoVoucher;
    }

    PrintVoucherMIT = async (objectToPrint, voucherArray, typeVoucher) => {
        const user = JSON.parse(localStorage.getItem('Timbra1currentUser'));
        const data = {
            Config: {
                TicketType: typeVoucher,
                PaperSize: "50"
            },
            Store: {
                Name: Datos_Empresa.Nombre + ' ' + Datos_Empresa.Sociedad,
                Address: (user.Branch.Address ?? "").substring(0,70) || "",
                RFC: user.Timbra.RFC || "",
                Phone: user.Branch.Phone || "",
                Logo: development === true ? ImageVoucherMIT_dev : ImageVoucherMIT_prod,
                Footer: `ESTE ES UN VOUCHER VALIDO ${development ? 'DE PRUEBAS' : ''} GENERADO POR LA TRANSACCIÓN ANTES MOSTRADA. CUALQUIER DEVOLUCIÓN DEBE DE SER SOLICITADA EL DIA DE EXPEDICIÓN DE ESTA TRANSACCIÓN ANTES DE LAS 11 DE LA NOCHE HORA CDMX, DE LO CONTRARIO NO SERA POSIBLE GENERAR LA DEVOLUCIÓN/CANCELACIÓN DE ESTA TRANSACCIÓN`,
            },
            Document: objectToPrint ?? null,
            Voucher: voucherArray ?? []

        }
        await apiClient.PrintVouchersMIT(data);
    };

    FillRequestPayments = (reqInfo) => {
        let model = new PaymentInfoMIT();

        model.cc_nombre = reqInfo?.cc_nombre?._text ?? "";
        model.cc_num = reqInfo?.cc_num?._text ?? "";

        model.cc_tp = reqInfo?.cc_tp?._text ?? "";
        model.cd_empresa = reqInfo?.cd_empresa?._text ?? "";

        model.cd_instrumento = reqInfo?.cd_instrumento?._text ?? "";
        model.cd_resp = reqInfo?.cd_resp?._text ?? "";

        model.cd_tipocobro = reqInfo?.cd_tipocobro?._text ?? "";
        model.cd_tipopago = reqInfo?.cd_tipopago?._text ?? "";
        model.cd_usrtransaccion = reqInfo?.cd_usrtransaccion?._text ?? "";

        model.cd_usuario = reqInfo?.cd_usuario?._text ?? "";
        model.fh_bank = reqInfo?.fh_bank?._text ?? "";

        model.fh_registro = reqInfo?.fh_registro?._text ?? "";
        model.nb_currency = reqInfo?.nb_currency?._text ?? "";


        model.nb_referencia = reqInfo?.nb_referencia?._text ?? "";
        model.nb_resp = reqInfo?.nb_resp?._text ?? "";

        model.nb_response = reqInfo?.nb_response?._text ?? "";
        model.nu_afiliacion = reqInfo?.nu_afiliacion?._text ?? "";

        model.nu_auth = reqInfo?.nu_auth?._text ?? "";
        model.nu_importe = reqInfo?.nu_importe?._text ?? "";

        model.nu_operaion = reqInfo?.nu_operaion?._text ?? "";
        model.nu_sucursal = reqInfo?.nu_sucursal?._text ?? "";

        model.tp_operacion = reqInfo?.tp_operacion?._text ?? "";

        return model;
    }



    render() {

        return (
            <>
                <div className="modal fade " id="terminalFunctions" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="terminalFunctions" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="container" id="advanced-search-form">
                                    <div className="row">
                                        <div className="col-md-12 text-left mt-2">
                                            <h4>FUNCIONES DE COBRO </h4>
                                        </div>
                                    </div>
                                    <form>
                                        {/* <div className="row">
                                            <div className="form-group mt-4  col-6">
                                                <label htmlFor="first-name">Código</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Código"
                                                    id="clientCode"
                                                    disabled={true}
                                                // value={updatebusinessPartner.CardCode || ""}
                                                />
                                            </div>
                                            <div className="mt-4  col-6">
                                                <div className="form-group formulario__grupo" id="grupo__rfc1">
                                                    <label htmlFor="first-name">RFC</label>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className="form-control form__input"
                                                            placeholder="Código"
                                                            id="rfc1"
                                                            // disabled={!editMode ? true : false}
                                                            // value={updatebusinessPartner.LicTradNum || ""}
                                                            onBlur={this.ValidateLicTradNum}
                                                            onChange={(event) => this.ChangeLicTradNum(event.target.value)}
                                                        />
                                                        <i className="form__validation-state fa fa-times-circle"></i>
                                                    </div>
                                                </div>
                                                <div className="form-group formulario__grupo" id="grupo__rfc1">
                                                    <p className="form__input-error" style={{ marginTop: "-14px" }}>{"Formato valido: (XAXX010101000)"}</p>
                                                    <p className="form__input-void" style={{ marginTop: "-14px" }}>RFC no puede ir vacio.</p>
                                                </div>
                                            </div>

                                            <div className="pr-3 col-12">
                                                <div className="form-group" id="grupo__fullName">
                                                    <label htmlFor="full-name">Nombre completo</label>
                                                    <div className="form__group-input">
                                                        <input
                                                            type="text"
                                                            className="form-control form__input"
                                                            placeholder="Nombre"
                                                            id="fullName"
                                                            name="fullName"
                                                            // disabled={!editMode ? true : false}
                                                            // value={updatebusinessPartner.U_FMB_AUX_CARDNAME || (updatebusinessPartner.CardName || "")}
                                                            onChange={(event) => this.ChangeCardName(event.target.value)}
                                                            onBlur={this.ValidateFullName}
                                                        />
                                                        <i className="form__validation-state fa fa-times-circle"></i>
                                                    </div>
                                                    <p className="form__input-error">Solo letras, min 3 y max 200.</p>
                                                    <p className="form__input-void">Nombre no puede ir vacio.</p>
                                                </div>
                                            </div>
                                        </div> */}
                                        <section>
                                            <ul className="nav nav-tabs" id="myTabTerminal" role="tablist">
                                                <li className="nav-item waves-effect waves-light">
                                                    <a className={true ? "nav-link active" : "nav-link"} id="request-terminal-tab" onClick={() => this.ChangeTabView("requestPayment")} data-toggle="tab" href="#requestPayment" role="tab" aria-controls="ingresos" aria-selected="true" style={{ color: "black" }}>
                                                        <h6>Consulta</h6>
                                                    </a>
                                                </li>
                                                <li className="nav-item waves-effect waves-light">
                                                    <a className={true ? "nav-link" : "nav-link active"} id="cancel-terminal-tab" onClick={() => this.ChangeTabView("cancelTransac")} data-toggle="tab" href="#cancelTransac" role="tab" aria-controls="general" aria-selected="false" style={{ color: "black" }}>
                                                        <h6>Cancelar transacción</h6>
                                                    </a>
                                                </li>

                                                <li className="nav-item waves-effect waves-light">
                                                    <a className="nav-link" id="rePrint-terminal-tab" data-toggle="tab" href="#reprintTerminal" onClick={() => this.ChangeTabView("reprintTerminal")} role="tab" aria-controls="account" aria-selected="false" style={{ color: "black" }} >
                                                        <h6>Re impresión</h6>
                                                    </a>
                                                </li>
                                            </ul>
                                            <div className="tab-content" id="myTabContent" style={{ border: "1px solid #dee2e6", borderTop: "none", }}>
                                                {/* ------------------------------------- CONSULTA --------------------------------------------------------- */}
                                                <div className={true ? "tab-pane fade active show" : "tab-pane fade"} id="requestPayment" role="tabpanel">
                                                    <div className="row p-3">
                                                        <div className="col-12 pr-2">
                                                            <div className="scrollAddressDetails">
                                                                <table>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td colSpan={2}>
                                                                                <div className="input-group mt-3">
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text">
                                                                                            <strong>Referencia:</strong>
                                                                                        </span>
                                                                                    </div>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        placeholder="Referencia del pago, cadena alfanumérica asociada al pago."
                                                                                        id="transacRef"
                                                                                        value={this.state.transacRef ?? ""}
                                                                                        onChange={(event) => this.ChangeTransacRef(event.target.value)}
                                                                                        onKeyPress={(eve) => {
                                                                                            if (eve.key === 'Enter') {
                                                                                                this.SendRequestPaymentByTabView();
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                <div className="input-group" style={{ width: "230px" }}>
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text">
                                                                                            <strong>Fecha:</strong>
                                                                                        </span>
                                                                                    </div>
                                                                                    <input
                                                                                        type="date"
                                                                                        className="form-control"
                                                                                        id="reqPaymentDate"
                                                                                        value={this.state.reqPaymentDate ?? ""}
                                                                                        onChange={(event) => this.ChangeRequestPaymentDate(event.target.value)}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                        </tr>

                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* ------------------------------------- CANCEL OPERATION --------------------------------------------------------- */}
                                                <div className={true ? "tab-pane fade" : "tab-pane fade active show"} id="cancelTransac" role="tabpanel" aria-labelledby="general-tab" style={{ maxHeight: "650px" }}>
                                                    <div className="row p-3">
                                                        <div className="col-12 pr-2">
                                                            <div className="scrollAddressDetails">
                                                                <table>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>
                                                                                <div className="input-group mt-3">
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text">
                                                                                            <strong>Codigo de operación:</strong>
                                                                                        </span>
                                                                                    </div>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        placeholder="Referencia del pago, cadena numérica asociada al pago."
                                                                                        id="transacRef"
                                                                                        value={this.state.operationCode ?? ""}
                                                                                        onChange={(event) => this.ChangeOperationCode(event.target.value)}
                                                                                        // onKeyPress={(eve) => {
                                                                                        //     if (eve.key === 'Enter') {
                                                                                        //         this.SendRequestPaymentByKey();
                                                                                        //     }
                                                                                        // }}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                <div className="input-group" >
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text">
                                                                                            <strong>Codigo de autorización:</strong>
                                                                                        </span>
                                                                                    </div>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        id="authorizationCode"
                                                                                        value={this.state.authorizationCode ?? ""}
                                                                                        onChange={(event) => this.ChangeAuthorizationCode(event.target.value)}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>
                                                                                <div className="input-group" style={{ width: "250px" }}>
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text">
                                                                                            <strong>Monto:</strong>
                                                                                        </span>
                                                                                    </div>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        id="amount"
                                                                                        value={this.state.amount ?? ""}
                                                                                        onChange={(event) => this.ChangeAmountValue(event.target.value)}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                        </tr>

                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* ------------------------------------------ CUENTA ----------------------------------------------- */}
                                                {<div className="tab-pane fade" id="reprintTerminal" role="tabpanel">
                                                    <div className="row p-3">
                                                        <div className="col-12 pr-2">
                                                            <div className="scrollAddressDetails">
                                                                <table>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>
                                                                                <div className="input-group mt-3">
                                                                                    <div className="input-group-prepend">
                                                                                        <span className="input-group-text">
                                                                                            <strong>Codigo de operación:</strong>
                                                                                        </span>
                                                                                    </div>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        placeholder="Numero de operación del pago, cadena numérica."
                                                                                        value={this.state.operationCode ?? ""}
                                                                                        onChange={(event) => this.ChangeOperationCode(event.target.value)}

                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className="input-group mb-3">
                                                                                    <div className="col-md-12 col-sm-12" style={{ marginTop: 20 }}>
                                                                                        <div className="radio font-weight-bold" style={{ fontSize: 13, marginTop: 0 }}>
                                                                                            <label>
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    checked={this.state.flagSendEMV_email}
                                                                                                    id="email_MIT"
                                                                                                    onChange={() => this.ChangeFlagMITEmail()}
                                                                                                    style={{ marginRight: '5px' }}
                                                                                                />{' '}
                                                                                                MIT correo
                                                                                            </label>
                                                                                        </div>

                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                        {this.state.flagSendEMV_email &&
                                                                            <tr>
                                                                                <td>
                                                                                    <div className="input-group" >
                                                                                        <div className="input-group-prepend">
                                                                                            <span className="input-group-text">
                                                                                                <strong>Email:</strong>
                                                                                            </span>
                                                                                        </div>
                                                                                        <input
                                                                                            type="text"
                                                                                            className="form-control"
                                                                                            id="emailAddress"
                                                                                            value={this.state.emailAddress ?? ""}
                                                                                            onChange={(event) => this.ChangeEmailAddress(event.target.value)}
                                                                                        />
                                                                                    </div>
                                                                                </td>
                                                                            </tr>

                                                                        }

                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                }
                                            </div>
                                        </section>
                                    </form>
                                    <div className='row'>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className="col-sm-12">
                                    <div className="m-2 row justify-content-end">
                                        {development &&
                                            <button type="button" className="btn-danger" onClick={() => this.DevilButton()}>
                                                No tocar
                                                {/* <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> */}
                                            </button>

                                        }
                                        <button type="button" className="btn-dark col-3 ml-2 mr-2" onClick={() => this.CheckPrinterConnection()}>
                                            <i className="fa fa-print" aria-hidden="true"></i>
                                        </button>
                                        <button type="button" className="btn-lg btn-secondary col-3 ml-2 mr-2" data-dismiss="modal" data-target="#terminalFunctions" data-toggle="modal">
                                            Cerrar
                                        </button>
                                        <button type="button" className="btn-lg btn-primary col-3 ml-2 mr-2" onClick={() => this.SendRequestPaymentByTabView()}>
                                            Enviar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (store) => {
    return {
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        enableSpinner: (value) => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TerminalFunctions)